<script setup lang="ts">
    import { toRefs } from "vue";
    import KButton from "@/components/Button.vue";

    const props = withDefaults(
        defineProps<{
            header: string;
            headerIcon?: string;
            variant?: "list";
            footerLinkLabel?: string;
        }>(),
        {
            variant: "list",
        }
    );

    const { header, headerIcon, variant, footerLinkLabel } = toRefs(props);

    const emit = defineEmits(["footerLinkCallback"]);

    const footerLinkCallback = () => {
        emit("footerLinkCallback");
    };
</script>

<template>
    <div class="card" :class="[`variant-${variant}`]">
        <div class="card-header">
            <img :src="headerIcon" />
            <h4>{{ header }}</h4>
        </div>
        <div class="card-body">
            <slot></slot>
        </div>
        <div class="card-footer">
            <KButton variant="link-no-outline" @click="footerLinkCallback">
                {{ footerLinkLabel }}
            </KButton>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .card {
        background-color: white;
        padding: 12px;
        height: 416px;
        width: 347px;
        border-radius: 8px;

        .card-header {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 18px;

            h4 {
                margin: 0;
            }
        }

        .card-body {
            height: 299px;
        }

        .card-footer {
            margin-top: 9px;
            display: flex;
            justify-content: flex-end;
        }

        &.variant-list {
            .card-body {
                overflow-y: scroll;
                display: flex;
                flex-direction: column;
                gap: 8px;
            }
        }
    }
</style>
